import type { Opco } from "types/Opco";
import getOpco from "utils/getOpco";

const cookiePolicyLinkMap = {
  de: "https://cdn.offers.vodafone.com/tnc/de/privacy-policy.html",
  en: "https://www.vodafone.co.uk/privacy",
  es: "https://www.vodafone.es/c/conocenos/es/vodafone-espana/quienes-somos/legal-y-regulatorio/politica-de-privacidad-y-cookies/",
  gb: "https://www.vodafone.co.uk/privacy",
  it: "https://www.vodafone.it/privati/area-supporto/contratti-aggiornamenti/privacy/web-privacy-policy-cookies.html",
  eg: "#",
  pt: "#",
  lw: "https://www.lowi.es/politica-de-cookies/",
  za: "https://www.vodacom.co.za/vodacom/terms/privacy-policy",
  ro: "https://www.vodafone.ro/personal/servicii-si-tarife/termeni-si-proceduri-legale/politica-de-utilizare-a-cookie-urilor/index.htm",
  cz: "#",
  tr: "https://www.vodafone.com.tr/gizlilik-ve-guvenlik-politikalari",
  gr: "https://rc.ppe2.k8s.prd.partnerservices.vodafone.com/subscriptionplus/gr/cookie-preferences",
  nl: "https://www.vodafone.nl/over-deze-website/cookies.shtml",
} as Record<Opco, string>;

const getCookiePolicyLink = () => cookiePolicyLinkMap[getOpco()];

export default getCookiePolicyLink;
